import ModalDialog from '@stone/components/modal/ModalDialog';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
const ExchangeModal = (props) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const [show, setShow] = useState(true);
    const { isMobile } = useMediaQueries();
    let contentLabel = '';
    let alertText = '';
    let newItemsCount = (_a = props.bag) === null || _a === void 0 ? void 0 : _a.exchangeModel.items.filter((item) => item.exchangeType === 'new-item').length;
    let sizeColorCount = (_b = props.bag) === null || _b === void 0 ? void 0 : _b.exchangeModel.items.filter((item) => item.exchangeType === 'size-color-type').length;
    let sameItemCount = (_c = props.bag) === null || _c === void 0 ? void 0 : _c.exchangeModel.items.filter((item) => item.exchangeType === 'same-item').length;
    if (!show) {
        return React.createElement(React.Fragment, null);
    }
    if (sizeColorCount >= 1 && !newItemsCount) {
        contentLabel = t('exchanges.choosenewsize');
        alertText = t('exchanges.colorsize.alerttext');
    }
    if (newItemsCount >= 1) {
        contentLabel = t('exchanges.chooseanewitem');
        alertText = t('exchanges.alerttext');
    }
    if (sameItemCount >= 1) {
        contentLabel = t('exchanges.sameitem');
        alertText = t('exchanges.sameitemtext');
    }
    return (React.createElement(ModalDialog, { className: "info-modal exchange-modal", isOpen: true, contentLabel: contentLabel, onRequestClose: () => setShow(false), hasDivisor: true, subtitle: alertText, fullHeight: isMobile, fullWidth: isMobile },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "info-modal__columns d-flex justify-between" },
                React.createElement("div", { className: "info-modal__single-column title" },
                    React.createElement("span", { className: "font__title" }, t('exchanges.exchangeamount'))),
                React.createElement("div", { className: "info-modal__single-column text-right" },
                    React.createElement("span", { className: "font__title" }, props.bag.exchangeModel.moneyAmount))))));
};
export default ExchangeModal;
